import React, { useState, useEffect } from "react";
import { IonButton, IonInput, IonLabel, IonItem, IonList } from "@ionic/react";

// Helper function to calculate place value
const calculatePlaceValue = (digit: number, position: number): number => {
    return digit * Math.pow(10, position);
};

const PlaceValue: React.FC = () => {
    const [question, setQuestion] = useState<any>(null);
    const [userInput, setUserInput] = useState("");
    const [feedback, setFeedback] = useState<string | null>(null);
    const [showImage, setShowImage] = useState(false);
    const [error, setError] = useState(false);


    document.title = "Mamas Guidance - Class One - Mathematics - Number Math - Place Value"; // Set page title

    const generateQuestion = () => {
        const number1 = Math.floor(Math.random() * 900) + 100; // Random 3-digit number
        const number2 = Math.floor(Math.random() * 900) + 100;

        const digitIndex1 = Math.floor(Math.random() * 3); // Random index for number1
        const digitIndex2 = Math.floor(Math.random() * 3); // Random index for number2

        const digits1 = number1.toString().split("").map(Number);
        const digits2 = number2.toString().split("").map(Number);

        const placeValue1 = calculatePlaceValue(digits1[digitIndex1], 2 - digitIndex1);
        const placeValue2 = calculatePlaceValue(digits2[digitIndex2], 2 - digitIndex2);

        console.log(digits1, digitIndex1, digits1[digitIndex1], placeValue1, placeValue2, placeValue1 + placeValue2)

        return {
            number1,
            number2,
            digit1: digits1[digitIndex1],
            digit2: digits2[digitIndex2],
            placeValue1,
            placeValue2,
            answer: placeValue1 + placeValue2,
        };
    };

    useEffect(() => {
        setQuestion(generateQuestion());
    }, []);

    const handleSubmit = (questionAnswer:any) => {
        console.log(question)
        console.log(userInput);
        console.log(questionAnswer);
        if (userInput == questionAnswer) {
            setShowImage(true);
            setTimeout(() => {
                setQuestion(generateQuestion());
                setUserInput("");
                setShowImage(false);
                setError(false);
            }, 5000);
        } else {
            setError(true);
        }
    };

    const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        setUserInput(event.target.value);
    };

    return (
        <>

            <div className="contentPart showMiddle placeValue">
                {showImage ? (
                    <div className="image-container">
                        <img 
                            style={{ height: '150px' }} 
                            className="img-fluid" 
                            src={process.env.REACT_APP_WELDONE_LINK} 
                            alt="Well Done" 
                        />
                    </div>
                ) : (
                    <>
                        {question && (
                            <div className="question-list">
                                <div className="text-center">
                                    <div>Place value of first {question.digit1} in {question.number1}</div>
                                    <div className="text-center"> + </div>
                                    <div>Place value of first {question.digit2} in {question.number2}</div>
                                    <div className="text-center"> = </div>
                                    <div className="mt-2 mb-2 showMiddleOfPage">
                                        <input
                                            value={userInput}
                                            type="number"
                                            onChange={handleChange}
                                            placeholder="-"
                                            className={`form-control blank-input ${error == true  ? 'error' : ''} `}
                                            />
                                    </div>
                                    <div className=" showMiddleOfPage"  >
                                        <div className="background-blue" onClick={(e) => handleSubmit(question.answer)}>
                                            Submit
                                        </div>
                                    </div>
                                </div>
                            </div>
                        )}
                    </>
                    )}
                </div>
        </>
    );
};

export default PlaceValue;
